// extracted by mini-css-extract-plugin
export default {"item":"Category_item__J9-wi","title":"Category_title__VLo5f","text":"Category_text__uFQ8T"};